import React from "react";
import { cn } from "@/lib/utils";

export const EmptyState = ({ icon: Icon, title, hint, action, className = "", testId = "empty-state" }) => (
  <div className={cn("og-card flex flex-col items-start gap-3 p-6", className)} data-testid={testId}>
    {Icon && (
      <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent text-foreground">
        <Icon className="h-5 w-5" aria-hidden="true" />
      </div>
    )}
    <div>
      <h3 className="font-heading text-base font-semibold">{title}</h3>
      {hint && <p className="mt-1 max-w-prose text-sm text-muted-foreground">{hint}</p>}
    </div>
    {action && <div className="pt-1">{action}</div>}
  </div>
);
